<app-modal #modal [title]="'Scansione QRCode/Barcode'">
    <zxing-scanner [tryHarder]="true" [autofocusEnabled]="true"  [formats]="formats" [autostart]="true" #scanner  (scanSuccess)="scanCompleteHandler($event)"></zxing-scanner>

</app-modal>